import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'

import Slick from 'vue-slick';

Vue.mixin({
  components: {
    swiper,
    swiperSlide,
    Slick
  },
  data() {
    return {
      homeSliderOpts: {
        // autoplay: {
        //   delay: 5000,
        // },
        speed: 1500,
        effect: 'fade', // "slide", "fade", "cube", "coverflow" or "flip"
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: '.slider-pagination',
          type: 'fraction', //"bullets", "fraction", "progressbar" or "custom"
          formatFractionCurrent: function (number) {
            return '0' + number;
          },
          formatFractionTotal: function (number) {
            return '0' + number;
          },
          renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' +
              '<hr class="normal mx-2">' +
              '<span class="' + totalClass + '"></span>';
          }
        },
        navigation: {
          nextEl: '.home-slider-button-next',
          prevEl: '.home-slider-button-prev',
        },
      },
      awardsSlickLeftOpts: {
        // autoplay: true,
        // autoplaySpeed: 1500,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        // infinite: true,
        rows: 5,
        arrows: false,
        asNavFor: '.award-slider-right',
        dots: true,
        appendDots: '#awards-pagination',
        responsive: [{
          breakpoint: 576,
          settings: {
            rows: 1,
          }
        }]
      },
      awardsSlickRightOpts: {
        // autoplay: true,
        // autoplaySpeed: 1500,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // infinite: true,
        rows: 5,
        arrows: false,
        rtl: true,
        asNavFor: '.award-slider-left',
        responsive: [{
          breakpoint: 576,
          settings: {
            rows: 1,
            // rtl: false,
          }
        }]
      }
    }
  },
});


// WEBPACK FOOTER //
// ./src/js/home.js